import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CallToSubscribeMutationVariables = Types.Exact<{
  mainEvents: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  locale: Types.Scalars['String'];
}>;


export type CallToSubscribeMutation = { __typename?: 'Mutation', callToSubscribe: { __typename?: 'Notification', id: string, createdAt: string, updatedAt: string, en?: { __typename?: 'NotificationMessage', title?: string | null, body?: string | null } | null, de?: { __typename?: 'NotificationMessage', title?: string | null, body?: string | null } | null } };


export const CallToSubscribeDocument = gql`
    mutation CallToSubscribe($mainEvents: [ID!]!, $locale: String!) {
  callToSubscribe(mainEvents: $mainEvents, locale: $locale) {
    id
    en {
      title
      body
    }
    de {
      title
      body
    }
    createdAt
    updatedAt
  }
}
    `;
export type CallToSubscribeMutationFn = Apollo.MutationFunction<CallToSubscribeMutation, CallToSubscribeMutationVariables>;

/**
 * __useCallToSubscribeMutation__
 *
 * To run a mutation, you first call `useCallToSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallToSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callToSubscribeMutation, { data, loading, error }] = useCallToSubscribeMutation({
 *   variables: {
 *      mainEvents: // value for 'mainEvents'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCallToSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<CallToSubscribeMutation, CallToSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallToSubscribeMutation, CallToSubscribeMutationVariables>(CallToSubscribeDocument, options);
      }
export type CallToSubscribeMutationHookResult = ReturnType<typeof useCallToSubscribeMutation>;
export type CallToSubscribeMutationResult = Apollo.MutationResult<CallToSubscribeMutation>;
export type CallToSubscribeMutationOptions = Apollo.BaseMutationOptions<CallToSubscribeMutation, CallToSubscribeMutationVariables>;